// extracted by mini-css-extract-plugin
export default {"statusButton":"status_statusButton__LJmn9","userStatusButton":"status_userStatusButton__VnDfb"};